import React from 'react';

export default function FlexWrapper({
    children,
    justify = 'unset',
    align = 'unset',
    direction = 'row',
}) {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: justify,
                alignItems: align,
                flexDirection: direction,
            }}
        >
            {children}
        </div>
    );
}
